import { NgModule } from '@angular/core';
import { asmTranslationChunksConfig, asmTranslationsEn } from '@spartacus/asm/assets';
import { AsmRootModule } from '@spartacus/asm/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [AsmRootModule],
  providers: [
    provideConfig({
      featureModules: {
        asm: {
          module: () => import('@spartacus/asm').then((m) => m.AsmModule),
        },
      },
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: asmTranslationsEn,
        chunks: asmTranslationChunksConfig,
      },
    } as I18nConfig),
  ],
})
export class AsmFeatureModule {}
